import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { ButtonBase, Typography } from '@material-ui/core';
import { ErrorSharp as ErrorIcon } from '@material-ui/icons';
import { DelaStarIcon } from '~/modules/common/components/Icons';
import useStyles from './useStyles';

export const ResourceMatchItemError = ({
  dataQeId,
  resourceRequest,
  setAnchorEl,
  setPopoverResourceRequest,
  narrow = false
}) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const resourceMatchItemErrorDataQeId = dataQeId
    ? `${dataQeId}_ResourceMatchItemError`
    : undefined;

  const handlePopover = useCallback(
    event => {
      setAnchorEl(event.currentTarget);
      setPopoverResourceRequest(resourceRequest);
    },
    [setAnchorEl, setPopoverResourceRequest, resourceRequest]
  );

  return (
    <div
      data-qe-id={resourceMatchItemErrorDataQeId}
      className={classes.itemRoot}
    >
      <ButtonBase className={classes.itemButton} onClick={handlePopover}>
        <div className={classes.itemInfo}>
          <div className={classes.itemContainer}>
            <div className={classes.itemTextContainer}>
              {narrow ? (
                <>
                  <DelaStarIcon />
                  <Typography variant="body2" color="error">
                    {formatMessage({
                      id: 'resourceMatchItem.error'
                    })}
                  </Typography>
                </>
              ) : (
                <>
                  <DelaStarIcon className={classes.itemDelaStarIconSmall} />
                  <Typography variant="caption" color="textSecondary">
                    {formatMessage({
                      id: 'resourceMatchItem.resourceMatcher'
                    })}
                  </Typography>
                </>
              )}
            </div>
            {!narrow && (
              <div className={classes.itemTextContainer}>
                <ErrorIcon className={classes.itemErrorIcon} color="error" />
                <Typography variant="body2" color="error">
                  {formatMessage({
                    id: 'resourceMatchItem.error'
                  })}
                </Typography>
              </div>
            )}
          </div>
        </div>
      </ButtonBase>
    </div>
  );
};

ResourceMatchItemError.propTypes = {
  dataQeId: PropTypes.string,
  resourceRequest: PropTypes.object.isRequired,
  setAnchorEl: PropTypes.func.isRequired,
  setPopoverResourceRequest: PropTypes.func.isRequired,
  narrow: PropTypes.bool
};

export default ResourceMatchItemError;
